import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { UserDataChangesListService } from './user-data-changes-list.service';
import { NotificationService } from '../../../../../common/services';
import { UserDataChangesModel } from '../models/user-data-changes.model';
import { UserDataChangesListInitialState, UserDataChangesListLoad } from './user-data-changes-list.actions';
import { Error, CustomHttpErrorResponse } from '../../../../../common/constants/error';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface UserDataChangesStateModel {
  items: UserDataChangesModel[];
}

const initialState: UserDataChangesStateModel = {
  items: [],
};

@State<UserDataChangesStateModel>({
  name: 'userUserDataChangesList',
  defaults: initialState,
})
@Injectable()
export class UserDataChangesListState {
  constructor(
    private userDataChangesListService: UserDataChangesListService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getState(state: UserDataChangesStateModel): UserDataChangesStateModel {
    return state;
  }

  @Selector()
  static getItems(state: UserDataChangesStateModel): UserDataChangesModel[] {
    return state.items;
  }

  @Action(UserDataChangesListLoad)
  getDataProtectionNoticeList(
    ctx: StateContext<UserDataChangesStateModel>,
    { payload }: UserDataChangesListLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.userDataChangesListService.getUserDataChangesList(payload).pipe(
      map((items: UserDataChangesModel[]) => {
        ctx.patchState({ items });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(UserDataChangesListInitialState)
  setInitialState(ctx: StateContext<UserDataChangesStateModel>): void {
    ctx.setState(initialState);
  }
}
